import { ExtractLightingDataRequest, extractLightingData } from "@/api";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

/**
 * @description mutation that extracts data from a pdf, and returns a binary excel file
 */
export function useExtractLightingData() {
  return useMutation({
    mutationFn: async (request: ExtractLightingDataRequest) => {
      const result = await extractLightingData(request);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al extraer datos del documento", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      return result.val;
    },
    retryDelay: (i) => i * 60 * 1000,
  });
}
